import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../store/store-keys'
import { barterReducer } from './state/barter.reducer'
import { BarterEffects } from './state/barter.effects'
import { barterListReducer } from './list/state/barter-list.reducer'
import { BarterListEffects } from './list/state/barter-list.effects'
import { lpisKulturaReducer } from './state/lpis-kultura.reducer'

@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.BarterFeature, barterReducer),
        StoreModule.forFeature(StoreKeysEnum.LpisKulturas, lpisKulturaReducer),
        StoreModule.forFeature(StoreKeysEnum.BarterListFeature, barterListReducer),
        EffectsModule.forFeature([BarterEffects, BarterListEffects]),
    ],
})
export class BarterStateModule {}
